import {
    PAY_ORDER_OTP_SUCCESS,
    PAY_ORDER_OTP_FAILED,
    PAY_ORDER_OTP_INVALID_REQUEST,
    PAY_ORDER_OTP_ACCOUNT_NOT_EXISTS,
    PAY_ORDER_OTP_INVALID_ACCOUNTTYPE,
    PAY_ORDER_OTP_INVALID_PHONE,
    PAY_ORDER_OTP_INVALID_CUSTOMER_ID,
    PAY_ORDER_OTP_NO_OF_REQUEST_EXCEEDED,
    PAY_ORDER_OTP_INVALID_TELCC,
    LOADING_PAY_ORDER_OTP,
    RESET_PAY_ORDER_OTP,
} from "../types";

const initialState = {
    isLoading: false,
    otpsuccess: false,
    otpfailed: false,
    otpinvalidRequest: false,
    otpaccountNotExists: false,
    otpinvalidAccountType: false,
    otpinvalidPhone: false,
    otpinvalidCustomerID: false,
    otpnoOfRequestExceeded: false,
    otpinvalidTelcc: false,
    data: {},
    message: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_PAY_ORDER_OTP:
            return {
                ...state,
                isLoading: true,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: {},
                message: ""
            };
        case PAY_ORDER_OTP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                otpsuccess: true,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: ""
            };
        case PAY_ORDER_OTP_FAILED:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: true,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "OTP Request Failed."
            };
        case PAY_ORDER_OTP_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: true,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "Invalid OTP Request."
            };
        case PAY_ORDER_OTP_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: true,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "Account Does Not Exist."
            };
        case PAY_ORDER_OTP_INVALID_ACCOUNTTYPE:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: true,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "Invalid Account."
            };
        case PAY_ORDER_OTP_INVALID_PHONE:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: true,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "Invalid Phone Number."
            };
        case PAY_ORDER_OTP_INVALID_CUSTOMER_ID:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: true,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "Invalid Customer ID."
            };
        case PAY_ORDER_OTP_NO_OF_REQUEST_EXCEEDED:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: true,
                otpinvalidTelcc: false,
                data: action.payload,
                message: "OTP Request Exceeded."
            };
        case PAY_ORDER_OTP_INVALID_TELCC:
            return {
                ...state,
                isLoading: false,
                otpsuccess: false,
                otpfailed: false,
                otpinvalidRequest: false,
                otpaccountNotExists: false,
                otpinvalidAccountType: false,
                otpinvalidPhone: false,
                otpinvalidCustomerID: false,
                otpnoOfRequestExceeded: false,
                otpinvalidTelcc: true,
                data: action.payload,
                message: "Invalid Country Code."
            };
        case RESET_PAY_ORDER_OTP:
            return (state = initialState);

        default:
            return state;
    }
};